import { createAction, props } from '@ngrx/store';
import { Currency, InvoiceLink, PaymentStatus, PaymentType } from '@api/backend';
import { ErrorResponse, Transaction } from '@core/models';
import { UserTransactionsViewFilter } from '@store/user';
import { PaymentModes } from '@store/payment/payment.reducer';

export enum EPaymentActions {
  initChargePayment = '[Payment] Init Charge Payment',

  updateChargeAmount = '[Payment] Update Charge Amount',
  clearChargeForm = '[Payment] Clear Charge Form',

  loadCurrencyList = '[Payment] Load Currency List',
  loadCurrencyListSuccess = '[Payment] Load Currency List Success',
  loadCurrencyListFailure = '[Payment] Load Currency List Failure',

  loadPaymentTypeList = '[Payment] Load Payment Type List',
  loadPaymentTypeListSuccess = '[Payment] Load Payment Type List Success',
  loadPaymentTypeListFailure = '[Payment] Load Payment Type List Failure',

  sendChargePaymentRequest = '[Payment] Send Charge Payment Request',
  sendChargePaymentRequestSuccess = '[Payment] Send Charge Payment Request Success',
  sendChargePaymentRequestFailure = '[Payment] Send Charge Payment Request Failure',

  initWithdrawPayment = '[Payment] Init Withdraw Payment',

  updateWithdrawAddress = '[Payment] Update Withdraw Address',
  clearWithdrawAddressError = '[Payment] Clear Withdraw Address Error',
  clearWithdrawForm = '[Payment] Clear Withdraw Form',

  sendWithdrawPaymentRequest = '[Payment] Send Withdraw Payment Request',
  sendWithdrawPaymentRequestSuccess = '[Payment] Send Withdraw Payment Request Success',
  sendWithdrawPaymentRequestFailure = '[Payment] Send Withdraw Payment Request Failure',


  loadPayments = '[Payment] Load Payments',
  loadPaymentsSuccess = '[Payment] Load Payments Success',
  loadPaymentsFailure = '[Payment] Load Payments Failure',

  loadTransactions = '[Payment] Load Transactions',
  loadTransactionsSuccess = '[Payment] Load Transactions Success',
  loadTransactionsFailure = '[Payment] Load Transactions Failure',

  loadTransactionsNextPage = '[Payment] Load Transactions Next Page',
  loadTransactionsNextPageSuccess = '[Payment] Load Transactions Next Page Success',
  loadTransactionsNextPageFailure = '[Payment] Load Transactions Next Page Failure',

  changeTransactionsViewFilter = '[Payment] Change Transactions View Filter',

  addPayments = '[Payment] Add Payments',
  addPaymentsSuccess = '[Payment] Add Payments Success',
  addPaymentsFailure = '[Payment] Add Payments Failure',

}

/**
 * Init Payment
 */
export const initChargePayment = createAction(
  EPaymentActions.initChargePayment,
);
export const initWithdrawPayment = createAction(
  EPaymentActions.initWithdrawPayment,
);

/**
 * Load Currency List
 */
export const loadCurrencyList = createAction(
  EPaymentActions.loadCurrencyList,
);
export const loadCurrencyListSuccess = createAction(
  EPaymentActions.loadCurrencyListSuccess,
  props<{ currencies: Array<Currency> }>(),
);
export const loadCurrencyListFailure = createAction(
  EPaymentActions.loadCurrencyListFailure,
  props<{ error: any }>(),
);

/**
 * Load Currency List
 */
export const loadPaymentTypeList = createAction(
  EPaymentActions.loadPaymentTypeList,
);
export const loadPaymentTypeListSuccess = createAction(
  EPaymentActions.loadPaymentTypeListSuccess,
  props<{ withdraw_types:  Array<PaymentType>, charge_types: Array<PaymentType> }>(),
);
export const loadPaymentTypeListFailure = createAction(
  EPaymentActions.loadPaymentTypeListFailure,
  props<{ error: any }>(),
);

/**
 * Send Charge Payment Request
 */
export const sendChargePaymentRequest = createAction(
  EPaymentActions.sendChargePaymentRequest,
);
export const sendChargePaymentRequestSuccess = createAction(
  EPaymentActions.sendChargePaymentRequestSuccess,
  props<{ invoice: InvoiceLink }>(),
);
export const sendChargePaymentRequestFailure = createAction(
  EPaymentActions.sendChargePaymentRequestFailure,
  props<{ error: any }>(),
);

/**
 * Clear charge form
 */
export const clearChargeForm = createAction(
  EPaymentActions.clearChargeForm,
);

/**
 * Update Withdraw Adress
 */
export const updateWithdrawAddress = createAction(
  EPaymentActions.updateWithdrawAddress,
  props<{ value: string }>(),
);

export const clearWithdrawAddressAsyncError = createAction(
  EPaymentActions.clearWithdrawAddressError,
);


/**
 * Send Withdraw Payment Request
 */
export const sendWithdrawPaymentRequest = createAction(
  EPaymentActions.sendWithdrawPaymentRequest,
);
export const sendWithdrawPaymentRequestSuccess = createAction(
  EPaymentActions.sendWithdrawPaymentRequestSuccess,
  // props<{ link: string }>(),
);
export const sendWithdrawPaymentRequestFailure = createAction(
  EPaymentActions.sendWithdrawPaymentRequestFailure,
  props<{ error: any }>(),
);


/**
 * Clear withdraw form
 */
export const clearWithdrawForm = createAction(
  EPaymentActions.clearWithdrawForm,
);

export const loadPayments = createAction(
  EPaymentActions.loadPayments,
);

export const loadPaymentsSuccess = createAction(
  EPaymentActions.loadPaymentsSuccess,
  props<{ payments: Array<any> }>(),
);

export const loadPaymentsFailure = createAction(
  EPaymentActions.loadPaymentsFailure,
  props<{ error: any }>(),
);

export const addPayments = createAction(
  EPaymentActions.addPayments,
  props<{ payment: any }>(),
);

export const addPaymentsSuccess = createAction(
  EPaymentActions.addPaymentsSuccess,
  props<{ payment: any }>(),
);

export const addPaymentsFailure = createAction(
  EPaymentActions.addPaymentsFailure,
  props<{ error: string }>(),
);

/**
 * Transactions
 */

export const loadTransactions = createAction(
  EPaymentActions.loadTransactions,
);
export const loadTransactionsSuccess = createAction(
  EPaymentActions.loadTransactionsSuccess,
  props<{ transactions: Array<Transaction>, nextPage?: number }>(),
);
export const loadTransactionsFailure = createAction(
  EPaymentActions.loadTransactionsFailure,
  props<{ error: any }>(),
);

export const loadTransactionsNextPage = createAction(
  EPaymentActions.loadTransactionsNextPage,
);
export const loadTransactionsNextPageSuccess = createAction(
  EPaymentActions.loadTransactionsNextPageSuccess,
  props<{ transactions: Array<Transaction>, nextPage?: number }>(),
);
export const loadTransactionsNextPageFailure = createAction(
  EPaymentActions.loadTransactionsNextPageFailure,
  props<{ error: ErrorResponse }>(),
);

export const changeTransactionsViewFilter = createAction(
  EPaymentActions.changeTransactionsViewFilter,
  props<{ currentView: UserTransactionsViewFilter }>(),
);

/**
 * Utils
 */
export const updateChargeAmount = createAction(
  EPaymentActions.updateChargeAmount,
  props<{ value: number }>(),
);

export const paymentActions = {
  setPaymentMode: createAction(
    '[Payment] Set Payment Mode',
    props<{ paymentMode: PaymentModes }>(),
  ),
  getPaymentStatus: createAction(
    '[Payment] Get Payment Status',
    // props<{ payment_id: string }>(),
  ),
  getPaymentStatusSuccess: createAction(
    '[Payment] Get Payment Status Success',
    props<{ status: PaymentStatus }>(),
  ),
  getPaymentStatusFailure: createAction(
    '[Payment] Get Payment Status Failure',
    props<{ error: ErrorResponse }>(),
  ),
  loadPayments: createAction(
    EPaymentActions.loadPayments,
  ),

  loadPaymentsSuccess: createAction(
    EPaymentActions.loadPaymentsSuccess,
    props<{ payments: Array<any> }>(),
  ),

  loadPaymentsFailure: createAction(
    EPaymentActions.loadPaymentsFailure,
    props<{ error: ErrorResponse }>(),
  ),
};
